module.exports = __webpack_public_path__ + "img/rubin_benefit_19_coach.94d9cc07.svg";